import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  height: 100%;
`

const Menu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 210px;
  z-index: 1000;
  padding: 4px 0;
  @media (max-width: 480px) {
    min-width: 160px;
  }
`

const MenuItem = styled.div`
  padding: 10px 14px;
  cursor: pointer;
  font-family: 'Proxima-Nova';

  &:hover {
    background: #f5f5f5;
  }
`

const PopoverMenu = ({ trigger, options = [] }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const toggle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setOpen((prev) => !prev)
  }

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <Wrapper ref={ref}>
      <Trigger onClick={(e) => toggle(e)}>{trigger}</Trigger>

      {open && (
        <Menu>
          {options.map((opt, i) => (
            <MenuItem
              key={i}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()

                opt.onClick()
                setOpen(false)
              }}
            >
              {opt.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Wrapper>
  )
}

export default PopoverMenu
